<template>
  <div class="info-banner">
    <div class="headline">
      <!-- logo -->
      <div class="logo" aria-label="Fareclock logo">
        <img src="/img/logo-symbol.svg" class="logo-icon" alt="" aria-hidden="true" />
        <span class="logo-wordmark">Fareclock</span>
      </div>
      
      <!-- title -->
      <div class="title">{{ title }}</div>
    </div>


    <!-- details -->
    <div class="details">
      <!-- details (list) -->
      <div v-if="detailsList" class="details-list">
        <ul class="list-container">
          <li v-for="(detail, index) in detailsList" :key="index">
            {{detail}}
          </li>
        </ul>
      </div>
      <!-- details (paragraph) -->
      <div v-if="detailsParagraph" class="details-paragraph"> {{ detailsParagraph }} </div>
      
      <!-- additional details -->
      <div v-if="additionalDetails" class="additional-details" v-html="additionalDetails"/>
    </div>

    <!-- call to action -->
    <div class="call-to-action">
      <b-button
        v-if="primaryCta"
        :class="secondaryCta ? 'primary-cta-btn tw:flex-1' : 'primary-cta-btn'"
        variant="primary"
        @click="primaryCta.action"
      >
        {{ primaryCta.text }}
      </b-button>
      <b-button
        v-if="secondaryCta"
        :class="primaryCta ? 'secondary-cta-btn tw:flex-1' : 'primary-cta-btn'"
        :variant="primaryCta ? 'link' : 'primary'"
        @click="secondaryCta.action"
      >
        {{ secondaryCta.text }}
      </b-button>
    </div>
    
  </div>
</template>

<script setup lang="ts">
export interface CtaButton {
  text: string
  action: () => void
}

export interface InfoBannerProps {
  title: string
  detailsList?: string[]
  detailsParagraph?: string
  additionalDetails?: string
  primaryCta?: CtaButton
  secondaryCta?: CtaButton
}

defineProps<InfoBannerProps>()
</script>

<style lang="css">
:root {
  --upselling-banner-width: min(100%, 380px)
}
</style>

<style lang="scss" scoped>
$primary: #171358;

.info-banner{
  @apply tw:bg-white tw:p-6 tw:space-y-5;
  color: $primary;
  border-radius: var(--p-dialog-border-radius); // use same border radius as primevue dialog for consistency

  .logo{
    @apply tw:flex tw:justify-center tw:items-center tw:gap-2 tw:mb-3;

    .logo-icon {
      width: 30px;
      height: 30px;
      flex-shrink: 0;
    }

    .logo-wordmark {
      font-size: 1.125rem;
      line-height: 1;
      font-weight: 800;
      letter-spacing: 0.02em;
      color: currentColor;
      text-transform: lowercase;
    }
  }
  .title{
    @apply tw:text-xl tw:font-bold tw:mb-4 tw:text-center;
    
  }

  .details{
    @apply tw:space-y-2;
    .details-list {
      .list-container {
        @apply tw:list-disc tw:mb-0;
        padding-left: 1.25rem;
      }
    }
    .details-paragraph {
      @apply tw:px-4 tw:text-center;
    }
    .additional-details{
      @apply tw:text-center;
    }
  }

  .call-to-action {
    @apply tw:flex tw:flex-wrap tw:justify-center;
    gap: 8px;
    .primary-cta-btn {
      @apply tw:text-white tw:font-bold tw:text-lg;
      background-color: $primary;
      border-color: $primary;
      width: max(50%, 20rem);
    }
    .secondary-cta-btn {
      @apply tw:font-bold tw:text-lg;
      color: $primary;
    }
  }
}
</style>
